/* eslint-disable @next/next/no-img-element */
"use client";

import RegisterForm from "../components/RegisterForm";

const Page = () => {
  return (
    <main className="min-h-screen bg-background">
      <RegisterForm />
    </main>
  );
};

export default Page;
